import React from 'react';
import SMFormFieldBaseView from 'components/dashboard/form/SMFormFieldBaseView';

class SMFormCheckBox extends SMFormFieldBaseView {
  
  constructor(props) {
    super(props);
    this.state = {
      checked: this.props.checked,
    };
  }
  
  componentDidMount() {
    
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({
      checked : nextProps.checked
    });
  }
  
  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }
  
  componentDidUpdate(prevProps, prevState) {
    
  }
  
  didChangeValue(e) {
    const checked = !this.state.checked;
    this.setState({ checked: checked });
    if(this.props.delegate && typeof this.props.delegate.checkBoxDidChangeValue === 'function'){
      this.props.delegate.checkBoxDidChangeValue(e);
    }
  }
  
  render() {
    
    return (
      <input 
        type="checkbox" 
        id={this.props.id} 
        name={this.props.name} 
        value={this.props.value} 
        checked={this.state.checked} 
        onChange={this.didChangeValue.bind(this)} 
        disabled={this.props.options.disabled}
      />
    );
  }
}
SMFormCheckBox.defaultProps = {
  options: {
    disabled: false
  }
};
export default SMFormCheckBox;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/form/SMFormCheckBox.jsx